import React, { useState } from "react";
import { MapPinIcon, PlusIcon, ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import AddressCard from "./AddressCard";

const AddressList = ({ addresses, onAddAddress, onEditAddress, onDeleteAddress }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <section aria-labelledby="addresses-title" className="bg-white rounded-lg shadow-md p-4 flex flex-col">
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={toggleExpansion}
            >
                <h2 id="addresses-title" className="text-xl font-semibold flex items-center gap-2">
                    <MapPinIcon className="w-5 h-5 text-primary" />
                    Adresse{addresses.length > 1 && 's'}
                </h2>

                <div className="flex items-center gap-2">
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onAddAddress();
                        }}
                        className="btn btn-primary btn-xs h-8 min-h-0 flex items-center gap-1"
                        aria-label="Ajouter une nouvelle adresse"
                    >
                        <PlusIcon className="w-3.5 h-3.5" />
                        Ajouter
                    </button>
                    {isExpanded ? (
                        <ChevronUpIcon className="w-5 h-5 text-gray-500" />
                    ) : (
                        <ChevronDownIcon className="w-5 h-5 text-gray-500" />
                    )}
                </div>
            </div>
            <p className="text-xs text-base-content/70 mt-1">
                Gérez vos adresses de livraison.
            </p>
            {isExpanded && (
                <div className="grid grid-cols-1 gap-3 mt-3 flex-grow">
                    {addresses.map((address) => (
                        <AddressCard
                            key={address.id}
                            address={address}
                            onEdit={onEditAddress}
                            onDelete={onDeleteAddress}
                        />
                    ))}
                </div>
            )}
        </section>
    );
};

export default AddressList; 